const emailBtn = document.querySelector('.opt_form button');
const optSignupEle = document.querySelector('.opt_signup');
const currentUrl = window.location.href;

if(currentUrl.includes('grid_list=list-view')){
  optSignupEle.classList.add('opt_list_view');
}

emailBtn.addEventListener('click', function(){
  let emailVal = document.getElementById('opt_email');
  //validate that 
  if(validateEmail(emailVal.value)){
    window.location.href = "https://www.brightlifedirect.com/account/register";
  }else{
    emailVal.classList.add('opt_error');
  }
});

function validateEmail(email){
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};